import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'O3_environment';

export interface IHealthCheck {
  version: string;
  releasedAt: string;
}

@Injectable({ providedIn: 'root' })
export class HealthCheckService {
  private readonly http = inject(HttpClient);

  getHealthCheck(): Observable<IHealthCheck> {
    return this.http.get<IHealthCheck>(`${environment.apiUrls['ops']}/public/health-check`);
  }
}
